export function scrollToId(id: string) {
    // There are cases in which the same id appears multiple times on the same page. For example, the know page contains contains the same DOM elements twice, once for mobile and once for desktop.
    // As a temporary fix, we are looping through all elements and are trying to scroll them into the view.
    const elements = document.querySelectorAll(`[id=${id}]`)
    if (elements.length == 0) {
        console.warn(`Element with id '#${id}' not found`)
        return
    }

    if (elements.length > 1) {
        console.warn(`Multiple elements with id '#${id}' found`)
    }

    for (const element of elements) {
        if ('scrollIntoView' in element) {
            try {
                element.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start',
                    inline: 'nearest',
                })
            } catch (e) {
                simpleScrollFallback(element)
            }
        } else {
            simpleScrollFallback(element)
        }
    }
}

function simpleScrollFallback(element: Element) {
    const top = element.getBoundingClientRect().top + window.pageYOffset
    window.scrollTo({
        top: top,
        behavior: 'smooth',
    })
}
